export default __webpack_public_path__ + "static/media/logo-eos.1e6aa739.svg";